<template>
    <div class="min-h-screen w-full flex flex-col bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="container mx-auto my-4 sm:my-8 px-4 sm:px-8">
            <div class="mb-4">
                <bread-crumb :items="breadCrumbItems"></bread-crumb>
            </div>

            <coming-soon
                :title="pageTitle"
                :show-button="true"
                button-text="Coming Soon"
                button-icon="clock"
            />
        </div>
    </div>
</template>

<script>
import BreadCrumb from "../../components/shared/BreadCrumb.vue";
import {
    getCampusConfig,
    getCategoryConfig,
    isValidCampus,
    isValidCategory,
} from "./config";

export default {
    name: "adpoly-campus-category",
    components: {
        BreadCrumb,
    },
    props: ["campus", "category"],
    created() {
        this.validateRoute();
    },
    watch: {
        campus: function () {
            this.validateRoute();
        },
        category: function () {
            this.validateRoute();
        },
    },
    computed: {
        campusConfig() {
            return getCampusConfig(this.campus);
        },
        categoryConfig() {
            return getCategoryConfig(this.campus, this.category);
        },
        campusTitle() {
            return this.campusConfig ? this.campusConfig.title : "";
        },
        categoryTitle() {
            return this.categoryConfig ? this.categoryConfig.title : "";
        },
        pageTitle() {
            if (!this.campusTitle || !this.categoryTitle) return "Coming Soon";
            return this.campusTitle + " - " + this.categoryTitle;
        },
        breadCrumbItems() {
            const campusKey = this.campusConfig ? this.campusConfig.key : "";
            return [
                { label: "Dashboard", path: "/dashboard" },
                { label: "ADPOLY", path: "/adpoly" },
                {
                    label: this.campusTitle || "Campus",
                    path: campusKey ? "/adpoly/" + campusKey : "/adpoly",
                },
                {
                    label: "Campus",
                    path: campusKey ? "/adpoly/" + campusKey + "/campus" : "/adpoly",
                },
                { label: this.categoryTitle || "Category" },
            ];
        },
    },
    methods: {
        validateRoute() {
            if (!isValidCampus(this.campus) || !isValidCategory(this.campus, this.category)) {
                this.$router.push({ path: "/notFound" });
            }
        },
    },
};
</script>
